import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import FolderCard from "@/features/shared/components/FolderCard"
import { useNavigate } from "react-router-dom"
import { ClickableItem, HealthPlan, HealthPlanData, HealthPlanPdfType } from "../../../utils/api-objects/HealthPlan"
import { saveEvent } from "../../../utils/apis/user-service"
import { handleDate } from "../../../utils/Functions"
import { useUserStore } from "../../../utils/stores/useUserStore"
import { HealthPlanDataBox, HealthPlanDataBoxWithCheckbox } from "./HealthPlanCard"

export const HealthPlanSection: React.FC<{
    healthPlan: HealthPlan,
}> = ({
    healthPlan,
}) => {
    const { sendEvent} = useCreateEvent()
        const { userData } = useUserStore()
        const email = userData.email
        const navigate = useNavigate()

        const handleNavigate = async(pdfType: HealthPlanPdfType) => {
            navigate(`/health-plan/pdfs?health_plan_id=${healthPlan.id}&type=${pdfType}`)

            if (!email) return
            saveEvent(
                email,
                `click_on_${pdfType}_folder`,
                (success) => { console.log() },
                (error) => { console.log(error) },
                "health_plan_page",
            )
            await sendEvent({
                event: EventType.CLICK,
                sub_category: "open_health_plan_folder",
                event_metadata: { folder: pdfType}
            })
        }

        const pdfCounts = {
            [HealthPlanPdfType.Materials]: healthPlan.pdf_data.filter(pdf => pdf.type === HealthPlanPdfType.Materials).length,
            [HealthPlanPdfType.Prescriptions]: healthPlan.pdf_data.filter(pdf => pdf.type === HealthPlanPdfType.Prescriptions).length,
        }

        const dataBoxes = [
            { title: "👩‍⚕️‍  Commento del medico", key: "comment", Component: HealthPlanDataBox },
            { title: "🥙  Alimenti consigliati", key: "food_suggested", Component: HealthPlanDataBoxWithCheckbox },
            { title: "💊  Integratori consigliati", key: "integrators_suggested", Component: HealthPlanDataBoxWithCheckbox },
            { title: "🩺  Check-up consigliati", key: "check_ups_suggested", Component: HealthPlanDataBoxWithCheckbox },
        ]

        return (
            <div className="space-y-[20px] flex flex-col">
                <div className="font-normal text-[12px] leading-[33px]">
                    Aggiornato il {handleDate(healthPlan.updated_at, "dd.MM.yyyy")}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-sm">
                    {dataBoxes.map(({ title, key, Component }) => {
                        const data = healthPlan.data[key as keyof HealthPlanData];

                        if (!data) return null;

                        const isClickableItemArray = (data: unknown): data is ClickableItem[] => {
                            return Array.isArray(data) && data.every(item => typeof item === "object" && "text" in item);
                        };

                        if (Component === HealthPlanDataBoxWithCheckbox && isClickableItemArray(data)) {
                            return (
                                <Component
                                    key={key}
                                    title={title}
                                    data={data}
                                    fullData={healthPlan.data}
                                    planId={healthPlan.id}
                                    source="health_plan_page"
                                />
                            );
                        } else if (Component === HealthPlanDataBox && Array.isArray(data)) {
                            return (
                                <Component
                                    key={key}
                                    title={title}
                                    data={data as string[]}
                                    source="health_plan_page"
                                />
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
                {healthPlan.pdf_data.length > 0 && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-sm">
                        {Object.entries(pdfCounts).map(([pdfType, count], index) =>
                            count > 0 ? (
                                // <PdfFolder
                                //     key={pdfType}
                                //     title={pdfType === HealthPlanPdfType.Materials ? "🗂️ Materiali di approfondimento" : "📄 Prescrizioni"}
                                //     onClick={() => handleNavigate(pdfType as HealthPlanPdfType)}
                                //     number={count}
                                // />
                                <FolderCard
                                    key={index}
                                    onClick={() => handleNavigate(pdfType as HealthPlanPdfType)} title={pdfType === HealthPlanPdfType.Materials ? "🗂️ Materiali di approfondimento" : "📄 Prescrizioni"}/>
                            ) : null
                        )}
                    </div>
                )}
            </div>
        )
    }
